import { useCallback } from "react";

const LOGIN_API_URL = "https://api.emboxvn.com/auth";

export const useAuthAPI = () => {
    // Request login code via email
    const requestCode = useCallback(async (email) => {
        try {
            const response = await fetch(`${LOGIN_API_URL}/request-code`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });
            
            return await response.json();
        } catch (error) {
            console.error("API error during request code:", error);
            return {
                isSuccess: false,
                message: "Network error during request code"
            };
        }
    }, []);

    // Verify login code
    const verifyCode = useCallback(async (email, loginCode) => {
        try {
            const response = await fetch(`${LOGIN_API_URL}/verify-code`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                    email, 
                    loginCode // Match the expected parameter name
                })
            });
            
            return await response.json();
        } catch (error) {
            console.error("API error during verification:", error);
            return {
                isSuccess: false,
                message: "Network error during verification"
            };
        }
    }, []);

    return {
        requestCode,
        verifyCode
    };
};